module.exports = __webpack_public_path__ + "static/img/361622302.1d302ae6.png";